import { render } from "./ShowSection.vue?vue&type=template&id=a04e5d98&scoped=true"
import script from "./ShowSection.vue?vue&type=script&lang=js"
export * from "./ShowSection.vue?vue&type=script&lang=js"

import "./ShowSection.vue?vue&type=style&index=0&id=a04e5d98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04e5d98"]])

export default __exports__